<template>
  <div>
    <v-container >
      <CRUDCriteria
        :showSearch="false"
        :showReset="true"
      >
        <template v-slot:criteriaRows>
          <v-row>
            <v-col cols="2">
              <v-select
                id="tmc-source-criteria-fy"
                label="By FY"
                :items="sortedFiscalYearRange"
                v-model.number="criteriaState.fiscalYear"
                @input="searchByCriteria"
              ></v-select>
            </v-col>
            <v-col cols="5">
              <v-text-field
                id="sourceWildCard"
                label="Wildcard search (source number, type, desc or sub desc)"
                v-uppercase=globalSettingItem.conEverythingToCaps
                v-model="criteriaState.wildcard"
                @input="wildcardSearchDelayed"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-btn
                  class="ml-3"
                  color="primary"
                  small
                  dense
                  @click="validateRecords"
                >
                  Validate Records
                </v-btn>
              <v-btn
                class="ml-3"
                color="primary"
                small
                dense
                @click="printSourceList"
              >
                Print Source List
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </CRUDCriteria>
      <CRUDList
        :canAdd="canAddToSharedList"
        :canEdit="true"
        :canSave="canEditSharedList"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :createNewItem="newItemDialog"
        :defaultSortBy="sortBy"
        toolbarTitle="Source"
        @loadCRUDList="handleLoadCRUDList"
        @upsertItem="upsrtSource"
        :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      >
        <template v-slot:[`editedItem`]="{}">
          <SourceEditedItem :baseCrudKey="baseCrudKey"
          />
        </template>
        <template v-slot:[`additionalActions`]="{}">
          <span v-if="!isNewItem() && canDeleteFromSharedList">
            <v-btn :class="`input-text-size`"
              text color="blue darken-1"
              @click="deleteSource"
              >Delete</v-btn>
          </span>
      </template>
      </CRUDList>
      <!-- GL Fund Error Dialog -->
    <v-dialog v-model="isRequiredToShowErrorDialog" max-width="600px" persistent>
      <v-card>
        <v-card-text class="mt-2">
          <!-- {{ currentGLFundError }} -->
          <v-alert type="error" outlined class="mb-2 mt-2">
            <strong>{{'Validation Errors'}}</strong>
          </v-alert>
          <div v-if="currentValidationError">
            <h4 class="mb-3">
              Record Details ({{ currentErrorIndex + 1 }} of {{ validationErrorData.length }}):
            </h4>
            <!-- Debug info - always show for now to help troubleshoot -->
            <!-- <div class="mb-3 pa-2" style="background-color: #f5f5f5; border: 1px solid #ddd;">
              <strong>Debug Info:</strong>
              <pre style="font-size: 12px;">{{ JSON.stringify(debugErrorInfo, null, 2) }}</pre>
            </div> -->
            <v-simple-table dense>
              <tbody>
                  <tr v-if="currentValidationError">
                  <!-- <td><strong>SourceSubSourceNumber</strong></td> -->
                  <td class="error--text">{{ (currentValidationError|| 'test') }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="hasMoreErrors"
            color="primary"
            text
            @click="showNextError"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            Continue ({{ currentErrorIndex + 1 }}/{{ validationErrorData.length }})
          </v-btn>
          <v-btn
            v-else
            color="primary"
            text
            disabled
          >
            <v-icon left>mdi-check</v-icon>
            Continue
          </v-btn>
          <v-btn color="error" text @click="hideErrorWindow">
            <v-icon left>mdi-close</v-icon>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapState,
  mapMutations,
} from 'vuex';

import CRUDList from '../../common/base/crud/CRUDList.vue';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import SourceEditedItem from './SourceEditedItem.vue';
import {
  toFiscalYear,
  getFYList,
} from '../../../util/shared/tmc-global';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { clients } from '../../../util/clients';

const { backendRest } = clients.direct;

const getHeaders = () => {
  const headers = [
    { text: 'Type', value: 'type', formatter: 'getFirstChar' },
    { text: 'Source', value: 'sourceSubSourceNumber' },
    { text: 'Description', value: 'sourceDescription' },
    { text: 'Sub Description', value: 'subSourceDescription' },
    { text: 'Alt Key', value: 'altKey' },
  ];
  return headers;
};

export default {
  name: 'SourceList',
  mixins: [GlobalToCaps, SharedListAccessControlMixin],
  components: {
    CRUDCriteria,
    CRUDList,
    SourceEditedItem,
  },
  data: () => ({
    baseCrudKey: 'sharedSource',
    delayTimerId: undefined,
    gridLoading: defaultGridLoading(),
    headers: [],
    sortBy: [
      {
        column: 'sourceSubSourceNumber',
        direction: 'asc',
      },
    ],
    isRequiredToShowErrorDialog: false,
    validationErrorData: [],
    currentErrorIndex: 0,
    currentErrorMessage: '',

  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
    this.criteriaState.fiscalYear = toFiscalYear(new Date(this.todaysDate));
    this.loadFiscalRegYears();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.shared.source.regYears || {};
        return getFYList(registerdYears);
      },
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    sortedFiscalYearRange() {
      return [...(this.fiscalYearRange || [])].sort((a, b) => b - a);
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    currentValidationError() {
      const hasErrors = this.validationErrorData.length > 0;
      const validIndex = this.currentErrorIndex < this.validationErrorData.length;
      if (hasErrors && validIndex) {
        const currentError = this.validationErrorData[this.currentErrorIndex];
        return currentError;
      }
      return this.validationErrorData; // Fallback for backward compatibility
    },
    hasMoreErrors() {
      return this.currentErrorIndex < this.validationErrorData.length - 1;
    },
  },
  methods: {
    manageGridLoading,
    ...mapActions(['reAuth', 'flashWarn']),
    ...mapActions(['reAuth', 'flashError']),
    ...mapActions(['reAuth', 'flashSuccess']),
    ...mapActions('shared/source', [
      'loadCmnSource',
      'upsertCmnSource',
      'loadFiscalRegYears',
      'deleteCmnSource',
      'validateCmnSource',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = this.criteriaState;
      manageGridLoading(this, true, 'Searching...');
      this.loadCmnSource({
        criteria,
        baseCrudKey,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    searchByCriteria() {
      this.handleLoadCRUDList();
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    hideErrorWindow() {
      this.isRequiredToShowErrorDialog = false;
      this.validationErrorData = [];
      this.currentErrorIndex = 0;
    },
    async validateRecords() {
      const { baseCrudKey } = this;
      if (this.isFiltersAvailable()) {
        if (window.confirm('Are you sure you want to validate these items?')) {
          const initialCriteria = {
            fiscalYear: this.criteriaState.fiscalYear,
          };
          const validationResult = await this.validateCmnSource({
            baseCrudKey,
            criteria: initialCriteria,
          });
          if (validationResult.isValid) {
            this.validationErrorData = validationResult.messages || [];
            this.isRequiredToShowErrorDialog = true;
            // this.flashError(`Validation failed! ${this.validationErrorData.join(', ')}`);
          } else {
            this.flashSuccess('All records are valid!');
          }
          this.$emit('loadCRUDList');
        }
      } else {
        this.flashWarn('Please select Fiscal year!');
      }
    },
    isFiltersAvailable() {
      return (this.criteriaState.fiscalYear);
    },
    upsrtSource(item) {
      const { baseCrudKey } = this;
      if (!this.isNewItem()) {
        if (!window.confirm('This update will reflect to all associated places, are you sure!')) {
          return false;
        }
      }
      this.upsertCmnSource({
        item,
        baseCrudKey,
      });
      return true;
    },
    initCriteria() {
      // reset criteria while merge flag is true
      this.criteriaState = {};
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        fiscalYear: toFiscalYear(new Date(this.todaysDate)),
        sourceDescription: null,
        subSourceDescription: null,
        sourceSubSourceNumber: null,
        type: null,
      };
      return newItem;
    },
    wildcardSearchDelayed() {
      // cancel pending call
      clearTimeout(this.delayTimerId);
      const { baseCrudKey } = this;
      // delay new call
      this.delayTimerId = setTimeout(async () => {
        await this.loadCmnSource({
          criteria: this.criteriaState, baseCrudKey,
        });
      }, 250);
    },
    async deleteSource() {
      const itemVal = this.item(this.baseCrudKey);
      if (window.confirm(`Are you sure you want to delete this Source ${itemVal.sourceSubSourceNumber}?`)) {
        const { baseCrudKey } = this;
        const deleteSourceObj = { _id: itemVal._id };
        await this.deleteCmnSource({ item: deleteSourceObj, baseCrudKey }).then(() => {
        }).catch((e) => {
          console.warn(e);
        });
      }
    },
    showNextError() {
      if (this.hasMoreErrors) {
        this.currentErrorIndex += 1;
      }
    },
    async printSourceList() {
      const { jwt } = await this.reAuth();
      const criteria = { ...this.criteriaState };

      const params = [];
      if (criteria.fiscalYear) {
        params.push(`fiscalYear=${criteria.fiscalYear}`);
      }
      if (criteria.wildcard) {
        params.push(`wildcard=${encodeURIComponent(criteria.wildcard)}`);
      }
      params.push(`token=${jwt}`);

      const queryString = params.length > 0 ? `?${params.join('&')}` : '';
      const url = `${backendRest.defaults.baseURL}/shared/source-list-report${queryString}`;
      window.open(url, '_blank');
    },
  },
};

</script>
